import { useGetProductCatalogBrandsByCriteriaQuery } from '@graphql/generated';

export type UseGetProductCatalogBrandsByCriteriaArgs = {
  brandPublicUrl: string;
};
export const useGetBrandDetails = (args: UseGetProductCatalogBrandsByCriteriaArgs) => {
  const { data, error, loading } = useGetProductCatalogBrandsByCriteriaQuery({
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    variables: {
      brandsUrlsList: [args.brandPublicUrl],
    },
  });

  return {
    brandDetails: data?.productCatalogBrandsByCriteria[0],
    loading,
    error,
  };
};
